var $alert_queue = $({});
var alert_queue_hash = {};

/**
 * Полифил для метода Object.hasOwn
 * @param {Object} object
 * @param {String} key
 * @return {Boolean}
 */
if (!Object.hasOwn) {
    Object.hasOwn = function (object, key) {
        return Object.prototype.hasOwnProperty.call(object, key);
    };
}

/**
 * @callback sweetAlertCallback
 * @param {Boolean} результат выбора пользователя в модальном окне
 */

/**
 * @callback jqueryQueueNextCallback
 */

/**
 * Возвращает колбэк для алерта
 *
 * Если передан пользовательский callback, в него будет передан следующий элемент очереди,
 * затем модифицированный пользовательский callback станет результатом работы данной функции.
 *
 * Вызов следующего элемента будет доступен внутри пользовательского колбэка по this.next().
 *
 * Результат выбора пользователя в окне сообщения будет передан в первом аргументе (Boolean) пользовательского колбэка:
 *  - true, пользователь нажал кнопку Ok
 *  - false, пользователь нажал кнопку Cancel (или клавишу Esc, или щёлкнул вне области модального окна)
 *
 *
 * Если пользовательский callback не передан, будет возвращён callback по умолчанию,
 * который просто вызовет следующий элемент очереди.
 *
 * @param {sweetAlertCallback} callback пользовательский колбэк модального окна
 * @param {jqueryQueueNextCallback} next колбэк следующего элемента очереди jQuery
 * @return {sweetAlertCallback}
 */
function swal_queue_callback(callback, next) {
    /**
     * Если колбэк не будет иметь аргументов, то, при наличии кнопки Cancel в окне сообщения
     * и нажатия пользователем кнопки Esc, вызов колбэка не произойдёт
     */
    if (callback) {
        // Если есть колбэк, пусть сам решает когда вызывать следующий элемент в очереди (и нужно ли вызывать)
        return function (result) {
            callback.apply({
                next: function () {
                    //  обязательно нужно ждать 500 мс, иначе следующее окно не рисуется
                    setTimeout(next, 500);
                }
            }, [result]);
        };
    } else {
        // Если колбэк не задан, используем свой колбэк по умолчанию, в котором просто вызываем следующий свиталерт
        return function (_result) {
            //  обязательно нужно ждать 500 мс, иначе следующее окно не рисуется
            setTimeout(next, 500);
        };
    }
}

/**
 * Блокируем кнопки модального окна из очереди, чтобы окно успело поставить атрибут visible,
 * если этого атрибута не будет, при нажатии на любую кнопку колбэк не будет вызван и окно закроется, порушив всю очередь
 *
 * Блокировка на 500 мс, т.к. именно столько ждёт sweetalert чтобы проставить этот атрибут после отрисовки окна
 *
 * @param {String} modal_class класс модального окна, кнопки которого нужно заблокировать
 */
function swal_queue_buttons_disable(modal_class) {
    $('.' + modal_class + ' button').attr('disabled', true);

    setTimeout(function () {
        $('.' + modal_class + ' button').attr('disabled', false);
    }, 500);
}

/**
 * Вызов swal в рамках очереди, спонсор очередей - объект jQuery
 *
 * Зачем нужен forced. В промежутке между несколькими окнами одной очереди фокус возвращается на форму редактирования/добавления,
 * валидатор которой возвращает код добавления нового элемента очереди, что может порождать бесконечную очередь.
 *
 * @param {Object} settings настройки sweetalert'а
 * @param {sweetAlertCallback} callback колбэк sweetalert'а
 * @param {Boolean} forced добавить элемент в очередь даже если там уже был аналогичный элемент
 */
function swal_queue(settings, callback, forced) {
    const custom_class = 'swal-queue';
    const queue_item_hash = JSON.stringify(settings) + callback;

    if (forced === undefined) {
        forced = false;
    }

    // Если такой элемент уже был в очереди, не добавляем его снова
    if (!forced && Object.hasOwn(alert_queue_hash, queue_item_hash)) {
        return;
    }

    // запоминаем в очереди данный элемент
    alert_queue_hash[queue_item_hash] = true;

    settings = $.extend(settings, {
        // Добавляем кастомный класс (хотя бы это нам позволяет эта устаревшая библиотека),
        customClass: custom_class,

        // Если на форме нет кнопки отмены, тогда блокируем закрытие окна по Esc, иначе колбэк не будет вызван, что развалит очередь
        allowEscapeKey: Object.hasOwn(settings, 'showCancelButton') && settings.showCancelButton
    });

    if ($('.' + custom_class).length) {
        // в данный момент выводится окно sweetalert'a, все последующие окна - в очередь
        $alert_queue.queue(custom_class, function (next) {
            Swal.fire(settings).then(swal_queue_callback(callback, next));

            swal_queue_buttons_disable(custom_class);
        });
    } else {
        // в данный момент нет окон алерта, выводим новое сразу
        Swal.fire(settings).then(swal_queue_callback(callback, () => {
            $alert_queue.dequeue(custom_class);
        }));

        swal_queue_buttons_disable(custom_class);
    }
}

/**
 * Позволяет запускать коллбэк 1 раз после N мс простоя
 *
 * Описание принципа:
 * https://css-tricks.com/debouncing-throttling-explained-examples/#debounce
 *
 * Альтернативный вариант реализации:
 * https://lodash.com/docs/4.17.15#debounce
 * https://github.com/lodash/lodash/blob/4.17.15/lodash.js#L10304
 *
 * @param {Function} fn
 * @param {Number} [delay=100]
 * @param {Boolean} [immediate=false] also known as leading edge https://css-tricks.com/debouncing-throttling-explained-examples/#leading-edge-or-immediate
 * @return {Function}
 */
function debounce(fn, delay, immediate) {
    let timeout_id;

    if (delay === undefined) {
        delay = 100;
    }

    return function () {
        const context = this;
        const args = arguments;

        if (immediate && !timeout_id) {
            fn.apply(context, args);
        }

        clearTimeout(timeout_id);

        timeout_id = setTimeout(function () {
            timeout_id = null;

            if (!immediate) {
                fn.apply(context, args);
            }
        }, delay);
    };
}

/**
 * Позволяет запускать коллбэк не чаще, чем 1 раз каждые N мс
 *
 * Описание принципа:
 * https://css-tricks.com/debouncing-throttling-explained-examples/#throttle
 *
 * Альтернативный вариант реализации:
 * https://lodash.com/docs/4.17.15#throttle
 * https://github.com/lodash/lodash/blob/4.17.15/lodash.js#L10897
 *
 * @param {Function} fn
 * @param {Number} [delay=100]
 * @param {Boolean} [ignore_last=false]
 * @return {Function}
 */
function throttle(fn, delay, ignore_last) {
    let previous_call_time = 0;
    let timeout_id;

    if (delay === undefined) {
        delay = 100;
    }

    return function () {
        const context = this;
        const args = arguments;

        const throttler = function () {
            previous_call_time = +new Date();
            fn.apply(context, args);
        };

        if (timeout_id) {
            clearTimeout(timeout_id);
            timeout_id = null;
        }

        const time_diff = +new Date() - previous_call_time;

        if (time_diff > delay) {
            throttler();
        } else if (!ignore_last) {
            timeout_id = setTimeout(throttler, delay - time_diff);
        }
    };
}

/**
 * Синхронная пауза. Внимание: создает большую нагрузку CPU, блокируя поток!
 *
 * @param {Number} ms
 * @return {undefined}
 */
function sleepSync(ms) {
    // используется getTime() для поддержки браузера IE 8
    const start = new Date().getTime();
    let now = start;

    while ((now - start) <= ms) {
        now = new Date().getTime();
    }
}

/**
 * Асинхронная пауза. Желательно использовать вместе с await
 *
 * @param {Number} ms
 * @return {Promise}
 */
function sleepAsync(ms) {
    return new Promise(function (resolve, _reject) {
        setTimeout(resolve, ms);
    });
}

/**
 * Асинхронный запуск массива колбеков, с задержкой между ними
 *
 * @param {Array} arrayCallbacks
 * @param {Number} ms
 * @return {undefined}
 */
function delayedCallBetween(arrayCallbacks, ms) {
    arrayCallbacks.forEach(function (func, index) {
        setTimeout(func, index * ms);
    });
}

/**
 * Analog for jQuery.inArray
 *
 * @param {mixed} needle
 * @param {array|object} haystack
 * @param {Boolean} strict
 * @return {Boolean}
 */
function in_array(needle, haystack, strict) {
    strict = !!strict;

    for (const key in haystack) {
        if ((strict && haystack[key] === needle) || (!strict && haystack[key] == needle)) {
            return true;
        }
    }

    return false;
}

/**
 *
 * @param {String} url
 * @param {String} key
 * @param {String} value
 * @return {String|*}
 */
function updateURLParameter(url, key, value) {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    const separator = url.indexOf('?') !== -1 ? '&' : '?';

    if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
    } else {
        return url + separator + key + '=' + value;
    }
}

/**
 *
 * @param {String} url
 * @param {String} parameter
 * @param {String|Number} value
 * @return {String}
 */
function removeURLParameter(url, parameter, value) {
    // prefer to use l.search if you have a location/link object
    const urlparts = url.split('?');

    if (urlparts.length >= 2) {
        // decode parameter array part '[' and ']' back
        const prefix = (encodeURIComponent(parameter) + '=').replace('%5B', '[').replace('%5D', ']');
        const pars = urlparts[1].split(/[&;]/g);

        // reverse iteration as may be destructive
        for (let i = pars.length; i-- > 0;) {
            // idiom for string.startsWith
            const pairValue = pars[i].split('=')[1];

            if (pars[i].lastIndexOf(prefix, 0) !== -1 && (typeof value === 'undefined' || value === pairValue)) {
                pars.splice(i, 1);
            }
        }

        if (pars.length >= 1) {
            url = urlparts[0] + '?' + pars.join('&');
        } else {
            url = '';
        }

        return url;
    } else {
        return url;
    }
}

/**
 *
 * @param {String} val
 * @return {String|Boolean}
 */
function getURLParameter(val) {
    let result = false;
    let tmp = [];
    const items = location.search.substr(1).split('&');

    for (let index = 0; index < items.length; index++) {
        tmp = items[index].split('=');

        if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
        }
    }

    return result;
}

/**
 * Разбивает тысячные разряды числа пробелом
 *
 * @param {int|float} number
 * @return {string}
 */
function formatNumberThousands(number) {
    return number.toString().replace(/\B(?=(\d{3})+\b)/g, ' ');
}

/**
 * Возвращает разницу между двумя датами в одном из указанных видов:
 * years, months, weeks, days, hours, minutes, seconds
 * Если нужно рассчитать разницу между текущей датой то вторым параметром
 * можно передать строку 'now'
 *
 * @param {String} date1
 * @param {String} date2
 * @param {String} interval
 * @return {undefined|number}
 */
function getDateDiff(date1, date2, interval) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const week = day * 7;

    interval = interval || 'days';

    date1 = new Date(date1).getTime();
    date2 = (date2 == 'now') ? new Date().getTime() : new Date(date2).getTime();

    const timediff = date1 - date2;

    if (isNaN(timediff)) {
        return NaN;
    }

    switch (interval) {
        case 'years':
            return date2.getFullYear() - date1.getFullYear();
        case 'months':
            return ((date2.getFullYear() * 12 + date2.getMonth()) - (date1.getFullYear() * 12 + date1.getMonth()));
        case 'weeks':
            return Math.floor(timediff / week);
        case 'days':
            return Math.floor(timediff / day);
        case 'hours':
            return Math.floor(timediff / hour);
        case 'minutes':
            return Math.floor(timediff / minute);
        case 'seconds':
            return Math.floor(timediff / second);
        default:
            return undefined;
    }
}

/**
 *
 * @param {jQuery} $jqueryElements
 * @return {undefined}
 */
function initFancybox($jqueryElements) {
    $jqueryElements = $jqueryElements || $('.fancybox');

    $jqueryElements.each(function () {
        const popup_type = ($(this).hasClass('fancybox-img') ? 'image' : null);

        $(this).fancybox({
            type: popup_type,
            onComplete: function () {
                if (typeof genFormInit != 'undefined') {
                    genFormInit($('#fancybox-content .form_gen_wrapper'));
                }

                if (typeof tableGenerator != 'undefined') {
                    tableGenerator.init();

                    // центрируем всплывашку сразу после инициализации таблицы, возможно после загрузки данных центрирование уже будет недоступно из-за размера
                    $.fancybox.center();
                }

                if (typeof $.fn.datepicker != 'undefined') {
                    $('#fancybox-content .datepicker').datepicker({
                        dateFormat: 'dd.mm.yy'
                    });
                }

                if (typeof $.fn.flatpickr != 'undefined') {
                    const flatpickrDatetimeFormat = 'd.m.Y, H:i';

                    $('#fancybox-content .datetime_flatpickr').flatpickr({
                        onClose(dates, currentdatestring, picker) {
                            /*
                             * принудительно обновляем введенные данные из-за случаев когда пользователь вручную ввел дату и время
                             * https://github.com/flatpickr/flatpickr/issues/161
                             */
                            picker.setDate(picker.input.value, true, picker.config.dateFormat);
                        },
                        allowInput: true,
                        enableTime: true,
                        enableSeconds: false,
                        dateFormat: flatpickrDatetimeFormat,
                        locale: 'ru',
                        minuteIncrement: 1
                    });
                }
            }
        });
    });
}

/**
 * Инициализация плагина flatpickr
 */
function init_flatpickr() {
    $('.datetime_flatpickr').flatpickr({
        enableTime: true,
        enableSeconds: true,
        dateFormat: 'd.m.Y H:i:S',
        locale: 'ru',
        minuteIncrement: 1,
        secondIncrement: 1
    });
}

/**
 * считаем количество символов после точки
 *
 * @param {String} str
 * @return {number}
 */
function symbAfterDot(str) {
    if (str && str.length) {
        return str.length - str.indexOf('.') - 1;
    }
}

/**
 *
 * @param {Object} object
 * @return {[]}
 */
function getObjectValues(object) {
    const array = [];

    for (const index in object) {
        array.push(object[index]);
    }

    return array;
}

/**
 *
 * @param {string} input
 * @param {int} pad_length
 * @param {string} pad_string
 * @param {int} pad_type
 * @return {string}
 */
function strPad(input, pad_length, pad_string, pad_type) {
    const STR_PAD_LEFT = 0;
    const STR_PAD_RIGHT = 1;
    const STR_PAD_BOTH = 2;

    let output = input.toString();

    pad_string = pad_string || '0';

    pad_type = (typeof pad_type === 'undefined' ? STR_PAD_RIGHT : parseInt(pad_type));

    while (output.length < pad_length) {
        if (pad_type === STR_PAD_RIGHT || pad_type === STR_PAD_BOTH) {
            output = output + pad_string;
        }

        if ((pad_type === STR_PAD_LEFT || pad_type === STR_PAD_BOTH) && output.length < pad_length) {
            output = pad_string + output;
        }
    }

    return output;
}

/**
 *
 * @param {string} input
 * @param {int} pad_length
 * @param {string} pad_string
 * @return {string}
 */
function leftPad(input, pad_length, pad_string) {
    const STR_PAD_LEFT = 0;

    return strPad(input, pad_length, pad_string, STR_PAD_LEFT);
}

/**
 *
 * @param {Function} callback
 * @param {*} param1
 * @param {*} param2
 * @param {*} param3
 * @return {*}
 */
function executeCustomCallback(callback, param1, param2, param3) {
    if (typeof callback === 'function') {
        return callback(param1, param2, param3);
    } else if (typeof window[callback] === 'function') {
        return window[callback](param1, param2, param3);
    } else {
        (new Function(callback))(param1, param2, param3);
    }
}

/**
 *
 * @param {array|string} messages
 * @param {callback} [callback]
 * @return {undefined}
 */
function showPrompts(messages, callback) {
    if (typeof messages === 'string') {
        messages = [messages];
    }

    if (!messages.length) {
        return;
    }

    callback = callback || function () {};

    const message = messages.shift();

    Swal.fire({
        title: 'Внимание',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Продолжить',
        cancelButtonText: 'Отмена'
    }).then((reslut) => {
        if (reslut.isConfirmed) {
            if (messages.length) {
                // еще есть другие сообщения для отображения
                setTimeout(function () {
                    // небольшая задержка чтобы swal мог нормально работать и пользователь понял что это другое окно
                    showPrompts(messages, callback);
                }, 500);
            } else {
                // на все вопросы отвечено положительно
                callback();
            }
        }
    });
}

/**
 *
 * @param {int|float} number
 * @param {bool} useThousandsSeparator
 * @param {int} precision
 * @param {bool} alwaysShowFraction
 * @return {string}
 */
function formatNumber(number, useThousandsSeparator, precision, alwaysShowFraction) {
    number = parseFloat(number) || 0;
    precision = (typeof precision === 'undefined' ? 2 : parseInt(precision));
    const isNeedHideEmptyCents = window.isNeedHideEmptyCents || function () {};

    let result_number = number;

    if (alwaysShowFraction || !isNeedHideEmptyCents()) {
        result_number = number.toFixed(precision);
    } else {
        result_number = (number % 1 ? number.toFixed(precision) : number);
    }

    if (useThousandsSeparator) {
        result_number = formatNumberThousands(result_number);
    }

    return result_number;
}

/**
 * Форматирует дробное число для текстового отображения с разделителем тысячных групп.
 * Отображать пустую дробную часть или нет зависит от настроен в "Управлении"
 *
 * @param {int|float} number
 * @param {int} precision
 * @param {bool} alwaysShowFraction
 * @return {string}
 */
function formatDecimalAsText(number, precision, alwaysShowFraction) {
    return formatNumber(number, true, precision, alwaysShowFraction);
}

/**
 * Форматирует дробное число для полей ввода форм БЕЗ разделителя тысячных групп для последующей обработки как дробное значение.
 * Отображать пустую дробную часть или нет зависит от настроен в "Управлении"
 *
 * @param {int|float} number
 * @param {int} precision
 * @param {bool} alwaysShowFraction
 * @return {string}
 */
function formatDecimalAsInputValue(number, precision, alwaysShowFraction) {
    return formatNumber(number, false, precision, alwaysShowFraction);
}

/**
 *
 * @link http://prototypejs.org/doc/latest/language/String/prototype/escapeHTML/
 * @link https://github.com/prototypejs/prototype/blob/d9411e5/src/prototype/lang/string.js#L408
 * @param {string} htmlString
 * @return {string}
 */
function escapeHTML(htmlString) {
    return htmlString.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/**
 * Меняет на верхний регистр первой буквы
 * @param {string} str
 * @return {string}
 */
function ucFirst(str) {
    return (str ? str[0].toUpperCase() + str.slice(1) : str);
}

/**
 *
 * @param {String} str
 * @return {String}
 */
function commaToDot(str) {
    return str.replace(/,/ig, '.');
}

/**
 * Принимает объект даты, возвращает строку в формате: dd.mm.yyyy
 *
 * @param {object} date
 * @return {string}
 */
function formatDate(date) {
    const dd = date.getDate();
    let mm = date.getMonth() + 1;
    if (mm < 10) {
        mm = '0' + mm;
    }
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
}

/**
 * Склоняем словоформу
 *
 * @param {Number} value
 * @param {Array} words
 * @return {string}
 */
function decline_word_form(value, words) {
    value = Math.abs(value) % 100;
    const num = value % 10;

    if (value > 10 && value < 20) {
        return words[2];
    }

    if (num > 1 && num < 5) {
        return words[1];
    }

    if (num == 1) {
        return words[0];
    }

    return words[2];
}

/**
 * https://github.com/egoist/promise.series/blob/master/index.js
 *
 * @param {array} tasks - Массив задач. Задача должна возращать промис.
 * @param {array} initial .- Изначально пустой массив, в который будут складываться результаты работы по каждой задаче.
 * @return {Promise}
 */
function promiseSeries(tasks, initial) {
    if (!Array.isArray(tasks)) {
        return Promise.reject(new TypeError('promise.series only accepts an array of functions'));
    }
    return tasks.reduce((current, next) => {
        return current.then(next);
    }, Promise.resolve(initial));
}

/**
 * Возвращает маску для поля "серия номер документа"
 *
 * @param {Number} document_type_id
 * @param {Number} country_id
 * @return {String}
 */
function getDocumentNumberMask(document_type_id, country_id) {
    switch (document_type_id) {
        case 1: // Паспорт
            if (country_id == 1) { // Россия
                return '9999 999999';
            }

            if (country_id == 3) { // Казахстан
                return '*********';
            }

            break;
        case 2: // Водительские права
            if (country_id == 1) {
                return '9999 999999';
            }

            if (country_id == 3) {
                return 'aa 9999999999';
            }

            break;
        case 3: // Заграничный паспорт
            if (country_id == 1) {
                return '99 9999999';
            }

            if (country_id == 3) {
                return '*********';
            }

            break;
        case 4: // Вид на жительство
            if (country_id == 1) {
                return '99 9999999';
            }

            if (country_id == 3) {
                return '';
            }

            break;
        case 5: // Временное удостоверение личности
            if (country_id == 1) {
                return '999999999999';
            }

            if (country_id == 3) {
                return '';
            }

            break;
        case 6: // Военный билет
            if (country_id == 1) {
                return 'aa 9999999';
            }

            if (country_id == 3) {
                return 'aa 9999999';
            }

            break;
        default:
            break;
    }

    return '';
}

/**
 * Меняет маску полю "серия номер документа"
 *
 * @param {jQuery} $form_wrapper
 */
function initMaskForDocumentNumberInput($form_wrapper) {
    const $form = $form_wrapper.find('form');

    const organization_country_id = $form_wrapper.find('input[name="organization_country_id"]').val();

    const document_type_id = parseInt($form.find('select[name=document_type]').val());

    const document_number_mask = getDocumentNumberMask(document_type_id, organization_country_id);

    const $document_number = $form.find('input[name=number]');

    const init_value_of_number_input = $document_number.val();

    $form.find('input[name=number_mask]').val(document_number_mask);

    $document_number.inputmask(document_number_mask);

    $form.find('select[name=document_type]').on('change', function () {
        const document_type_id = parseInt($form.find('select[name=document_type]').val());

        const document_number_mask = getDocumentNumberMask(document_type_id, organization_country_id);

        $form.find('input[name=number_mask]').val(document_number_mask);

        $document_number.inputmask(document_number_mask);

        if (!$document_number.val() && init_value_of_number_input) {
            $document_number.val(init_value_of_number_input);
        }
    });
}

/**
 *
 * @param {String|Number} what
 * @param {Object} where
 * @return {Boolean}
 */
function object_key_exists(what, where) {
    if (what in where) {
        return true;
    }

    return false;
}
